export default {
    computed: {
        browserLanguage() {
            let lang = navigator.languages
                ? navigator.languages[0]
                : navigator.language || navigator.userLanguage;
            if (lang.startsWith("zh")) {
                lang = ["zh", "zh-HK"].includes(lang) ? "zh-CN" : lang;
            } else {
                lang = lang ? lang.split("-")[0] : "en";
            }
            return this.mapData.locales.includes(lang) ? lang : (this.mapData.locales.includes('en') ? 'en' : this.mapData.default_locale);
        },
        defaultLanguage() {
            if (!this.checkValidLocale() && this.mapData.use_browser_language) {
                return this.browserLanguage;
            }
            
            return this.mapData.default_language == "browser"
                ? this.browserLanguage
                : this.mapData.current_locale;
        },
    },
    methods: {
        loadDefaultLanguage() {
            var self = this;
            this.mySmartMap.on("load", function () {
                if (
                    !self.checkValidLocale() &&
                    self.mapData.use_browser_language
                ) {
                    window.location.href =
                        self.currentMapLink + `/${self.defaultLanguage}`;
                }
                self.switchLanguage(self.defaultLanguage);
            });
        },
        checkValidLocale() {
            let parts = window.location.pathname.split("/");
            let locale = parts[parts.length - 1];
            return this.mapData.locales.includes(locale);
        },
    },
};
